import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import { Select } from '../../Form';

import styles from './adjustMatchesModal.scss';

const timeIncrements = [5, 10, 15, 20, 25, 30];
const adjustmentOptions = timeIncrements.map((mins) => ({
    id: mins,
    value: mins,
    label: `${mins} mins`,
}));

const AdjustMatchesModal = (props) => {
    const { onCloseClick, onConfirmAdjust } = props;

    const [adjustmentMinutes, setAdjustmentMinutes] = useState(adjustmentOptions[0].id);

    const onConfirmClick = () => {
        onConfirmAdjust(parseInt(adjustmentMinutes));
    };

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.adjustMatchesModal}
            onCloseClick={onCloseClick}
            closeOnClickOutside={false}
            config={{
                fullScreen: false,
                noPadding: false,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <div className={styles.header}>
                Adjust selected matches?
            </div>
            <Select
                attributeToShow="label"
                attributeToSave="id"
                themeV3
                options={adjustmentOptions}
                formGroupCssClass="mt8 mb8"
                controlled
                value={adjustmentMinutes}
                onChange={setAdjustmentMinutes}
            />
            <div className={`${styles.description} mt8`}>
                Matches with specific time(s) added will have their start times updated on schedules and draws.
            </div>
            <div className={`${styles.footer} d-flex`}>
                <button
                    className="btn btn-default mr8 flex-1"
                    type="button"
                    onClick={onCloseClick}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-primary flex-1"
                    type="button"
                    onClick={onConfirmClick}
                >
                    Adjust
                </button>
            </div>
        </Popup>
    );
};

AdjustMatchesModal.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onConfirmAdjust: PropTypes.func.isRequired,
};

AdjustMatchesModal.defaultProps = {};

export default AdjustMatchesModal;
